import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UnitTableComponent } from './unit-table.component';
import { UnitProviders } from '../../../../../_models';
import { TableModule } from '../../../../../shared/table';

@NgModule({
    declarations: [UnitTableComponent],
    imports: [
        CommonModule,
        TableModule,
        RouterModule
    ],
    exports: [UnitTableComponent],
    providers: [UnitProviders]
})
export class UnitTableModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-table/unit-table.module.ts